import { currency } from "../../../utils/currency/currency";
import { Input } from "../../ui/input";

export function CurrencyField({
  item,
  value,
  error,
  helperText,
  disabled,
  onChange,
  className,
}) {
  const formatCurrency = (value) => {
    if (!value) return "";
    // Convert to number - remove any non-numeric characters first
    const cleanValue = value.toString().replace(/[^0-9.-]/g, "");
    const numericValue = parseFloat(cleanValue) || 0;

    return currency(numericValue, {
      symbol: "", // no currency symbol
      separator: ",", // thousand separator
      decimal: ".", // unused since no decimals
      precision: 0, // ✅ no decimals
    }).format();
  };

  const handleChange = (e) => {
    const input = e.target.value;
    // Allow decimal input but store the raw numeric value (including decimals)
    const numericValue = input.replace(/[^0-9.-]+/g, "");
    // Only pass valid numbers, defaulting to empty string for invalid input
    const parsedValue = numericValue === "" || numericValue === "-" ? "" : numericValue;
    onChange({ target: { value: parsedValue } });
  };

  return (
    <div className="relative">
      <span className={`absolute left-3 top-1/2 -translate-y-1/2 text-sm pointer-events-none ${
        disabled ? "text-[#595959]" : "text-gray-500"
      }`}>$</span>
      <Input
        type="text"
        placeholder={item.placeholder || "0"}
        value={formatCurrency(value)}
        onChange={handleChange}
        disabled={disabled}
        className={`${error ? "border-red-500 hover:border-red-500 focus:border-red-500 pl-8" : "bg-white border-[#D9D9D9] pl-8"} ${
          disabled ? "disabled:text-[#595959]" : ""
        } ${className || ""}`}
      />
    </div>
  );
}
